import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Callbacks, DxReportViewer, ExportSettings, RequestOptions, TemplateEngine,} from 'devexpress-reporting-react/dx-report-viewer'
import {useParams} from "react-router-dom";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.material.orange.light.compact.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";
import {parseISO} from "date-fns";
import {loadMessages, locale} from "devextreme/localization";
import frMessage from "devextreme/localization/messages/fr.json";
import frReport from './dx-reporting.fr.json'
import {IEditorViewModel} from "@devexpress/analytics-core/analytics-widgets-native";
import {CheckBox} from "devextreme-react/check-box";
import {ValueChangedEvent} from "devextreme/ui/check_box";


const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

function reviver(key: any, value: string) {
    if (dateFormat.test(value)) {
        return parseISO(value);
    }

    return value;
}

let parametersModel: any = undefined;
const CheckBoxParameterEditor = (props: { data: IEditorViewModel }) => {
    const {data} = props;
    return <CheckBox value={data.value} onValueChanged={(e: ValueChangedEvent) => {
        const {fieldName} = data.info.editor as { fieldName: string };
        const parameter = (parametersModel.parameters.filter((f: any) => f.path === fieldName) || [])[0];

        if (parameter)
            parameter.value = e.value;
    }}/>
}

const ReportViewer = ({reportName}: { reportName: string }) => {
    const isHttps = location.protocol === "https:";
    const apiUrl = useMemo(() => (process.env.NODE_ENV !== 'production' ? (isHttps ? import.meta.env["VITE_APP_API_URL_DEV_HTTPS"] : import.meta.env["VITE_APP_API_URL_DEV"]) : `${window.location.origin}/api`), []);
    const templateEngine = new TemplateEngine();
    templateEngine.setTemplate('checkBox-editor', CheckBoxParameterEditor);

    const {id} = useParams();
    const reportUrl = `/${id}/${reportName}`;

    useEffect(() => {
        loadMessages(frMessage);
        locale("fr");
    }, [frMessage]);

    const onCustomizeParameterEditors = useCallback((param: { args: any }) => {
        const {args} = param;
        if (args.parameter.type === 'System.DateTime') {
            args.info.editor = {...args.info.editor};
            args.info.editor.extendedOptions = {
                ...args.info.editor.extendedOptions,
                dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
                useMaskBehavior: true,
                applyValueMode: "instantly",
                onFocusIn: (e: any) => {
                    e.element.querySelector('.dx-texteditor-input').select();
                }
            };
        }

        if (args.parameter.type === 'System.Boolean') {
            args.info.editor = {header: 'checkBox-editor', fieldName: args.parameter.name};
        }
    }, [])

    const beforeRender = useCallback(({sender, args}: any) => {
        if (args && args.reportPreview) {
            args.reportPreview.showMultipagePreview = true;
        }
        var previewModel = sender.GetPreviewModel();
        parametersModel = previewModel?.parametersModel;
    }, []);

    const parametersSubmitted = useCallback(({args}: any) => {
        localStorage.setItem(`${reportName}-parameters`, JSON.stringify(args.Parameters));
    }, [reportName]);

    const parametersInitialized = useCallback(({args}: any) => {
        const item = localStorage.getItem(`${reportName}-parameters`);
        const parameters: { Value: any, Key: string, TypeName: String }[] = JSON.parse(item || "[]");
        parameters.forEach(param => {
            const parameter = args.ActualParametersInfo.filter((f: any) => f.parameterDescriptor.name === param.Key)[0];
            if (parameter)
                parameter.value = param.Value;

        });
        args.ShouldRequestParameters = true;
    }, [reportName]);

    const parametersReset = useCallback(() => {
        localStorage.removeItem(`${reportName}-parameters`);
    }, [reportName]);

    const customizeLocalization = ({args, sender}: any) => {
        args.LoadMessages(frReport);
        sender?.UpdateLocalization({
            'Loading...': 'Chargement en cours...',
            'Waiting for parameter values...': 'En attente des paramètres...',
            'Select All': "Sélectionner tous"
        });
    };
    return (
        <DxReportViewer reportUrl={reportUrl} height={"100%"} templateEngine={templateEngine}>
            <RequestOptions invokeAction={"/DXXRDV"} host={apiUrl}/>
            <ExportSettings showPrintNotificationDialog={false}/>
            <Callbacks CustomizeLocalization={customizeLocalization} CustomizeParameterEditors={onCustomizeParameterEditors} BeforeRender={beforeRender} ParametersSubmitted={parametersSubmitted} ParametersInitialized={parametersInitialized} ParametersReset={parametersReset}/>
        </DxReportViewer>
    )
}
export default ReportViewer;